import styled from '@emotion/styled';

import { useState } from 'react';

import useCountDownTimer from '../../hooks/useCountDownTimer';
import COLOR from '../../../shared/constant/colorset';
import LottieTimer from './LottieTimer';

const Container = styled.div`
  display: flex;
`;

const TimeUnits = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 136px;
  font-size: 32px;
  font-weight: 800;
  color: ${COLOR.kurlyGray800};
`;

const formatTime = (time?: number): string => {
  if (time === undefined) {
    return '00';
  }
  return time > 9 ? time.toString() : `0${time.toString()}`;
};

interface Props {
  endDate: Date;
  dealEnded: boolean;
  className?: string;
  onEnd(): void;
}

export default function Timer({ endDate, onEnd, dealEnded, className }: Props) {
  const [lottiePlay, setLottiePlay] = useState(true);

  const handleEndTimer = () => {
    onEnd();
    setLottiePlay(false);
  };

  const { hours, minutes, seconds } = useCountDownTimer({
    endDate, onEnd: handleEndTimer,
  });

  return (
    <Container className={className}>
      <LottieTimer
        className="lottie-timer"
        play={lottiePlay}
      />
      <TimeUnits className="time-units">
        {dealEnded ?
          <span>TIME OUT</span> :
          <>
            <span>{formatTime(hours)}</span>
            <span>{formatTime(minutes)}</span>
            <span>{formatTime(seconds)}</span>
          </>
        }
      </TimeUnits>
    </Container>

  );
}
